export default __webpack_public_path__ + "static/media/106_mikroo.7ee46e1c.webp";